module.exports = __webpack_public_path__ + "static/icon-astronaut-1c75b74dbbb23635739b11aa8f0a8016.svg";